import React from "react";
import I18N from "oc-modules/oc-I18N";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { useParams } from "react-router";
import Grid from "@material-ui/core/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { DialogContent, DialogTitle } from "@material-ui/core";

export default function BoothDetails({ setOpenBoothDetails }) {
  const params = useParams();
  // finds current exhibition + booth
  const exhibition = APP.richMetadata.metadata.Exhibitions.find(
    (exhi) => exhi.id == params.exhibitionId
  );
  const booth = exhibition.BoothSet.BoothsForBoothSets.find(
    (bth) => bth.Booth.id == APP.arrangement?.state?.booth.id
  )?.Booth;
  if(!booth) console.warn('current booth not found!');

  const selectedComb = APP.arrangement?.state?.selectedComb;

  const getDefaultArticleForBooth = (booth) => {
    const defaultForm = APP.richMetadata.metadata.FormsForBooths.find(
      (formforbooth) => formforbooth.Booth == booth
    );
    return defaultForm?.Article;
  };

  const interiorList = APP.arrangement.partslist.parts.filter(
    (part) => part.type == "BasicEquipment"
  );

  return (
    <>
      <DialogTitle style={{ padding: "12px" }}>
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton size="large" onClick={() => setOpenBoothDetails(false)} color="black">
            <CancelIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Box component={Grid} spacing={2} container>
            <Box component={Grid} item xs={12} lg={6}>
              {selectedComb.Thumbnail && (
                <Box
                  sx={{ width: "100%", padding: "5px", alignSelf: "center", marginBottom: "20px" }}
                  onMouseDown={() => {}}
                  onTouchStart={() => {}}
                >
                  <div
                    style={{
                      height: "350px",
                      width: "100%",
                      backgroundImage: `url("${selectedComb.Thumbnail}")`,
                      backgroundSize: "cover",
                      backgroundColor: "rgb(251 251 251 / 0%)",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  />
                </Box>
              )}
            </Box>

            <Box component={Grid} item xs={12} lg={6}>
              <Typography
                variant="h5"
                style={{ marginBottom: "16px", fontWeight: 700, color: "#C91113" }}
              >
                {booth?.Displayed_Name}
              </Typography>
              <Typography variant="h5">
                {getDefaultArticleForBooth(booth)
                  ? APP.formatter.format(getDefaultArticleForBooth(booth).Preis)
                  : ""}
              </Typography>
            </Box>

            <Box component={Grid} item xs={12} lg={6}>
              <Typography
                variant="h5"
                style={{
                  marginBottom: "20px",
                  fontWeight: "700",
                }}
              >
                {I18N("BoothDetails")}
              </Typography>
              <Typography
                style={{ marginBottom: "20px" }}
                dangerouslySetInnerHTML={{ __html: selectedComb.Description }}
              />
            </Box>

            {interiorList.length > 0 && (
              <Box component={Grid} item xs={12} lg={6}>
                <Typography
                  variant="h5"
                  style={{
                    marginBottom: "20px",
                    fontWeight: 700,
                  }}
                >
                  {I18N("BasicEquipment")}
                </Typography>
                {/* <Typography style={{marginBottom: '20px'}} dangerouslySetInnerHTML={{ __html: selectedComb.BasicEquipment }} /> */}
                <TableContainer component={Box} style={{ marginBottom: "20px" }}>
                  <Table>
                    <TableBody>
                      {interiorList.map((interior, i) => (
                        <TableRow key={i + 1}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{interior.title}</TableCell>
                          <TableCell>
                            <Box sx={{ color: "#C91113", fontWeight: 700 }}>{interior.amount}</Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
    </>
  );
}
